import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a2abaad200095001491776a_1781188574042_90900663/ftcindustries/src/app/page.tsx");
